import { history } from "../helpers/history";
import { closeSession } from "../helpers/session";
import { Request, RequestWithAuthorization } from "../helpers/request";
import { actions as notificationActions } from "../redux/ducks/notification";
import { actions as userActions } from "../redux/ducks/user";
import { redirectRoute } from "../config/routes";

const TOKEN_KEY = process.env.REACT_APP_TOKEN_KEY;

export const signIn = (credentials) => (dispatch) => {
  const request = new Request();

  request.post("/login", credentials, (response) => {
    // it save token in localStorage for persist the token when of page is reloaded
    localStorage.setItem(TOKEN_KEY, response.token);
    history.push(redirectRoute.private);

    return dispatch(userActions.signIn(response.user));
  });
};

export const signOut = () => (dispatch) => {
  closeSession();
  return dispatch(userActions.signOut());
};

export const signUp = (body) => (dispatch) => {
  const request = new Request();
  request.post("/users-client/register", body, (response) => {
    history.push(redirectRoute.public);

    return dispatch(
      notificationActions.set({
        severity: "success",
        message: "Tu cuenta ha sido creada por favor inicia sesión",
      })
    );
  });
};

export const getUserData = () => (dispatch) => {
  const request = new RequestWithAuthorization();
  request.get("/users/me", (response) => dispatch(userActions.set(response)));
};
